import { useSelector } from 'react-redux'
import { selectPlacesListStructure } from '@/features/domain/lists'
import { useEditingStateWithCtx } from '@/atoms'
import { useSearchList } from './useSearchList'

export function useFilter() {
  const { editing } = useEditingStateWithCtx('place')
  const { query, setQuery } = useSearchList()
  const listStructure = useSelector(selectPlacesListStructure)

  return {
    query,
    editing,
    setQuery,
    noEntries: listStructure.totalItems === 0,
  }
}
